
export { default } from '@atlaskit/analytics-next-stable-react-context';
export type { AnalyticsReactContextInterface } from '@atlaskit/analytics-next-stable-react-context';